import * as React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Layout } from 'antd';
import { palette } from '../theme/palette';
import { LinkCSS } from './LinkCSS';
import { VarnishContext } from './VarnishContext';
export class Footer extends React.PureComponent {
    static defaultProps = {
        setPageBackground: true,
    };
    getBackgroundColor = (bgcolor, contrast) => {
        if (bgcolor) {
            return bgcolor;
        }
        return contrast ? palette.background.dark : palette.common.white;
    };
    render() {
        const contrast = this.props.variant === 'dark';
        const bgcolor = this.getBackgroundColor(this.props.backgroundColor, contrast);
        return (React.createElement(VarnishContext.Consumer, null, ({ layout }) => (React.createElement(StyledFooter, { contrast: contrast, layout: layout, bgcolor: bgcolor, className: this.props.className },
            this.props.setPageBackground ? (React.createElement(WithPageBackground, { bgcolor: bgcolor })) : null,
            this.props.children ? (this.props.children) : (React.createElement("span", null,
                React.createElement("a", { href: "https://allenai.org" }, "\u00A9 The Allen Institute for Artificial Intelligence"),
                ' ',
                "- All Rights Reserved |",
                ' ',
                React.createElement("a", { href: "https://allenai.org/privacy-policy" }, "Privacy Policy"),
                " |",
                ' ',
                React.createElement("a", { href: "https://allenai.org/terms" }, "Terms of Use"),
                " |",
                ' ',
                React.createElement("a", { href: "https://allenai.org/business-code-of-conduct" }, "Business Code of Conduct")))))));
    }
}
const WithPageBackground = createGlobalStyle `
    html, body {
        background: ${({ bgcolor }) => bgcolor.hex};
    }
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledFooter = styled(({ contrast, ...rest }) => React.createElement(Layout.Footer, { ...rest })) `
    && {
        background: ${({ bgcolor }) => bgcolor.hex};
        color: ${({ theme, contrast }) => contrast
    ? theme.palette.text.contrast.toString()
    : theme.palette.text.primary.toString()};
        text-align: ${({ layout }) => (layout !== 'left-aligned' ? 'center' : null)};
        a[href] {
            ${({ contrast }) => (contrast ? LinkCSS.contrast() : null)};
        }
    }
`;
//# sourceMappingURL=Footer.js.map